import { I18nComponente } from "@/types/gerais"

export const routeri18n: I18nComponente = {
  "pt-BR": {
    tituloDaRotaDeAtividades: "Calendário de atividades",
    tituloDaRotaDeTiposDeAtividade: "Tipos de atividade",
    tituloDaRotaDeCriarTipoDeAtividade: "Criar tipo de atividade",
    tituloDaRotaDeEditarTipoDeAtividade: "Editar tipo de atividade",
    tituloDaRotaDeGestaoDeTravamentos: "Gestão de travamentos",
    tituloDaRotaDeLogin: "Login",
    tituloDaRotaDeRecuperacaoDeSenha: "Recuperação de senha",
    tituloDaRotaDeCriarNovaSenha: "Criar nova senha",
    tituloDaRotaDeSingleSignOn: "Login por single sign on",
    tituloDaRotaDeEstatisticas: "Estatísticas",
    tituloDaRotaDeImportacoes: "Importações",
    tituloDaRotaDeProfissionais: "Profissionais",
    tituloDaRotaDeCriarProfissional: "Criar profissional",
    tituloDaRotaDeEditarProfissional: "Editar profissional",
    tituloDaRotaDeCategoria: "Criar ou editar categorias",
    tituloDaRotaDeCriarAtributo: "Criar atributo",
    tituloDaRotaDeProjetos: "Projetos",
    tituloDaRotaDeCriarProjeto: "Criar projeto",
    tituloDaRotaDeEditarProjeto: "Editar projeto",
    tituloDaRotaDeCriarGrupo: "Criar grupo",
    tituloDaRotaDeRecursos: "Recursos",
    tituloDaRotaDeCriarOuEditarTipoDeRecurso: "Criar ou editar tipo de recurso",
    tituloDaRotaDeCriarAtributos: "Criar atributos",
    tituloDaRotaDeCriarOuEditarRecurso: "Criar ou editar recurso",
    tituloDaRotaDeUsuarios: "Usuários",
    tituloDaRotaDeCriarUsuario: "Criar usuário",
    tituloDaRotaDeEditarUsuario: "Editar usuário",
  },
  "es-CO": {
    tituloDaRotaDeAtividades: "Agenda",
    tituloDaRotaDeTiposDeAtividade: "Tipos de actividad",
    tituloDaRotaDeCriarTipoDeAtividade: "Añadir tipo de actividad",
    tituloDaRotaDeEditarTipoDeAtividade: "Editar tipo de actividad",
    tituloDaRotaDeGestaoDeTravamentos: "Control de congelamientos",
    tituloDaRotaDeLogin: "Iniciar sesión",
    tituloDaRotaDeRecuperacaoDeSenha: "Recuperación de contraseña",
    tituloDaRotaDeCriarNovaSenha: "Añadir nueva contraseña",
    tituloDaRotaDeSingleSignOn: "Inicio de single sign on",
    tituloDaRotaDeEstatisticas: "Estadísticas",
    tituloDaRotaDeImportacoes: "Importaciones",
    tituloDaRotaDeProfissionais: "Profesionales",
    tituloDaRotaDeCriarProfissional: "Añadir profesional",
    tituloDaRotaDeEditarProfissional: "Editar profesional",
    tituloDaRotaDeCategoria: "Añadir o editar categorías",
    tituloDaRotaDeCriarAtributo: "Añadir atributo",
    tituloDaRotaDeProjetos: "Proyectos",
    tituloDaRotaDeCriarProjeto: "Añadir proyecto",
    tituloDaRotaDeEditarProjeto: "Editar proyecto",
    tituloDaRotaDeCriarGrupo: "Añadir grupo",
    tituloDaRotaDeRecursos: "Recursos",
    tituloDaRotaDeCriarOuEditarTipoDeRecurso: "Añadir o editar tipo de recurso",
    tituloDaRotaDeCriarAtributos: "Añadir atributos",
    tituloDaRotaDeCriarOuEditarRecurso: "Añadir o editar recurso",
    tituloDaRotaDeUsuarios: "Usuarios",
    tituloDaRotaDeCriarUsuario: "Añadir usuario",
    tituloDaRotaDeEditarUsuario: "Editar usuario",
  }
}
